import { Component, AfterViewInit, DoCheck, OnChanges } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { FileUploader } from 'ng2-file-upload';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { InterfaceMappingService } from '../../../service/interface-mapping/interface-mapping.service';
import { config } from '../../../util/config';
const URL = 'https://foo.bar.com';

@Component({
  selector: 'app-root',
  templateUrl: 'wa0053.component.html',
  styleUrls: ['wa0053.component.scss']
})
export class Wa0053Component implements AfterViewInit, DoCheck, OnChanges {
  public componentTitle = 'WA0053:データマッピング(アップロード)';
  private ownerId: number;
  private ownerResult: any;
  private working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public config = config;
  private gridHelper: AgGridHelper;
  private production = environment.production;
  private backgroundColor: string;
  private updprogramCd = 'wa0053';
  private filetypes;
  private queryParam;
  private rowData;
  private uploadobjects;
  private uploadobjects_objectname;
  private selectUploadObjectId: number = 0;
  private uploadpatterns;
  private uploadObjectsPatternId;
  private loadStartAt;
  private uploader: FileUploader;
  private hasBaseDropZoneOver: boolean;
  private hasAnotherDropZoneOver: boolean;
  private response: string;
  private errormessage = '';
  public errorInfo: string = '';
  public selecterrorInfo: string = '';
  public error: boolean = false;
  private active: boolean = false;
  private errmsg: any = '';

  private isShowSendLoading = false;
  private isSubmitButtonEnabled = false;

  private errorList: object[] = [];
  private uploadpatternsAll = [];

  constructor(
    private interfaceMappingService: InterfaceMappingService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }

    this.uploader = new FileUploader({
      url: URL,
      disableMultipart: true
    });

    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    this.response = '';

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    //document.getElementById('wrap').style.overflow = 'auto';
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;

    if (this.uploader.queue.length > 1) {
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.hasBaseDropZoneOver = false;
      this.hasAnotherDropZoneOver = false;
      this.uploader.clearQueue();
    } else {
      this.errorInfo;
    }
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public onFileSelected() {
    let inputElement = <HTMLInputElement>document.getElementById('fileupload');
    inputElement.value = null;
    this.errorList = [];


    if (this.uploader.queue.length > 1) {
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.hasBaseDropZoneOver = false;
      this.hasAnotherDropZoneOver = false;
      this.uploader.clearQueue();
    } else {
      var filename = this.uploader.queue[0].file.name;
      var index = filename.lastIndexOf('.');
      var suffix = filename.substr(index + 1);
      if (suffix !== 'xls' && suffix !== 'xlsx' && suffix !== 'csv') {
        this.errorInfo = 'ファイル形式が異なります。ご確認ください。';
        this.hasBaseDropZoneOver = false;
        this.hasAnotherDropZoneOver = false;
        this.uploader.clearQueue();
      } else {
        this.errorInfo = '';
      }
    }
  }

  ngDoCheck() {
    this.isSubmitButtonEnabled = this.uploader.queue.length > 0;

  }

  ngOnChanges() {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.isShowSendLoading = true;
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.queryParam = this.route.snapshot.queryParamMap.get('upload_objects_id');
      sessionStorage.setItem('queryParam', this.queryParam);
      console.log(sessionStorage.getItem('queryParam'));
      this.uploader.clearQueue();
      this.interfaceMappingService
        .uploadobjects()
        .then(outputJson => {
          this.isShowSendLoading = false;
          this.filetypes = outputJson.uploadobjects;
          // tslint:disable-next-line:prefer-const
          let matchData = this.filetypes.filter(function (item, index) {
            // tslint:disable-next-line:triple-equals
            if (item.uploadObjectId == this) {
              return true;
            }
          }, this.queryParam);

          if (matchData.length !== 1) {
            this.errorInfo = 'マッピング種別が認識出来ません。';
          }
          sessionStorage.setItem('uploadobjects', JSON.stringify(matchData[0]));
          this.uploadobjects = sessionStorage.getItem('uploadobjects');

          if (this.uploadobjects !== null) {
            this.uploadobjects = JSON.parse(this.uploadobjects);
            this.uploadobjects_objectname = this.uploadobjects.objectName;
          }

          this.interfaceMappingService
            .uploadpattern(this.uploadobjects.uploadObjectId)
            // tslint:disable-next-line:no-shadowed-variable
            .then(outputJson => {
              this.isShowSendLoading = false;
              this.uploadpatternsAll = outputJson.uploadpatterns;
              this.filterUploadPatterns();
            })
            .catch(error => {
              this.isShowSendLoading = false;
            });
        })
        .catch(error => {
          this.isShowSendLoading = false;
        });
    });

  }

  filterUploadPatterns () {
    const resultOwner = []
    const resultCommon = [];
    this.uploadpatternsAll.forEach(up => {
      if (!this.ownerId) {
        resultCommon.push(up)
        return true;
      }
      const { owners } = up;
      if (owners.length === 0) {
        resultCommon.push(up)
      } else if (owners.filter(o => o.ownerId === this.ownerId).length > 0) {
        resultOwner.push(up)
      }
    })
    this.uploadpatterns = resultOwner.concat(resultCommon)
    this.selectUploadObjectId = this.uploadpatterns.length > 0 ? this.uploadpatterns[0].uploadObjectsPatternId : 0
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  changeOwner(ownerId) {
    if (ownerId !== null) {
      if (ownerId !== undefined) {
        this.ownerId = parseInt(ownerId);
      } else {
        this.ownerId = undefined;
      }
    } else {
    }
    this.filterUploadPatterns()
  }

  onSubmit() {
    this.isShowSendLoading = true;

    if (this.working) return;
    this.working = true;
    
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    } else {
      this.ownerId = undefined;
    }
    if (this.uploadobjects.uploadObjectId == 51) this.ownerId = 0;

    if (this.ownerId === undefined && this.uploadobjects.uploadObjectId != 51) {
      this.errorInfo = '荷主を選択してください。';
      this.isShowSendLoading = false
      this.working = false;
      return;
    } else {
      this.errorInfo = '';
    }

    if (this.uploader.queue.length < 1) {
      this.errorInfo = 'ファイルを選択してください';
      this.isShowSendLoading = false;
      this.working = false;
      return;
    } else {
      this.errorInfo = '';
    }

    if (!this.isSubmitButtonEnabled)
      return;
    
      // tslint:disable-next-line:prefer-const
    let matchData = this.uploadpatterns.filter(function (item, index) {
      // tslint:disable-next-line:triple-equals
      if (item.uploadObjectsPatternId == this) {
        return true;
      }
    }, this.selectUploadObjectId);

    if (matchData.length !== 0) {
      sessionStorage.setItem('uploadpattern', JSON.stringify(matchData[0]));
      this.uploadObjectsPatternId = matchData[0].uploadObjectsPatternId;
      this.loadStartAt = matchData[0].loadStartAt;
      this.selecterrorInfo = '';
      this.error = false;
    } else {
      this.isShowSendLoading = false;
      this.working = false;
      this.selecterrorInfo = 'データマッピング定義の指定をしてください。';
      this.error = true;
      sessionStorage.removeItem('uploadpattern');
      return;
    }
    this.interfaceMappingService
      .mappedupload(this.ownerId, this.uploader.queue[0]._file, this.uploadobjects.uploadObjectId, this.uploadobjects.objectCode, this.uploadObjectsPatternId, this.loadStartAt, '0', '0')
      .then(outputJson => {
        sessionStorage.setItem('SuccessInfoMessage', 'アップロードが完了しました。' + outputJson.readCount + '件を取り込みました。');
        this.uploader.clearQueue();
        this.errorList = [];
        this.isShowSendLoading = false;
        this.working = false;
      })
      .catch(error => {
        this.catchError(this.commonService.getErrorList(error));
        this.isShowSendLoading = false;
        this.working = false;
      });
  }

  errchange() {
    this.errorInfo = '';
    this.errorList = [];
    let matchData = this.uploadpatterns.filter(function (item, index) {
      if (item.uploadObjectsPatternId == this) {
        return true;
      }
    }, this.selectUploadObjectId);

    if (matchData.length !== 0) {
      this.error = false;
      this.active = true;
    } else {
      this.error = true;
      this.active = false;
    }
  }

  catchError(errorList) {
    this.errorList = errorList;
    this.errorInfo = 'アップロードでエラーが発生しました。下部のエラーメッセージを確認してください';
  }

  onDeleteAttachment(index) {
    this.errorInfo = '';
    this.uploader.removeFromQueue(this.uploader.queue[index]);
    this.errorList = [];
  }

  ownerInputChanged(ownerId: string) {
    this.errorInfo = '';
    this.changeOwner(ownerId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0053/wa0053.component.ts